import * as types from '../actions/types';

const INITIAL_STATE = {
  error: '',
  list: [],
  totalAmountOfTransactions: 0,
  fetching: true,
  transactionTypes: [],
  entityTypes: [],
  filters: [],
  filtersObj: {},
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case types.SET_FETCHING_TRANSACTIONS:
      return { ...state, fetching: true, list: [], error: '' };
    case types.SET_TRANSACTIONS_ERROR:
      return { ...state, error: action.payload, fetching: false };
    case types.SET_TRANSACTIONS_LIST:
      return { ...state, list: action.payload, fetching: false };
    case types.SET_TOTAL_AMOUNT_OF_TRANSACTIONS:
      return { ...state, totalAmountOfTransactions: action.payload };
    case types.SET_TRANSACTION_TYPES:
      return { ...state, transactionTypes: action.payload };
    case types.SET_ENTITY_TYPES:
      return { ...state, entityTypes: action.payload };
    case types.SET_TRANSACTION_FILTERS:
      return { ...state, filters: action.payload.filters, filtersObj: action.payload.filtersObj };
    case types.SET_INSURED_PROJECTS_MAPPINGS:
      return { ...state, transactionsProjectInsuredData: action.payload || [] };
    case types.SET_INSURED_PROJECTS_MAPPINGS_ERROR:
      return { ...state, errorInsuredProjects: action.payload };
    default:
      return state;
  }
};
